import React from 'react'
import { FormattedMessage } from 'react-intl'

import { RAMBLA_URL } from '../../../constants/appLinks'
import Button from '../../../components/shared/Button/Button'
import HeroArt from './HeroArt'
import {
  HeroSection,
  HeroDescription,
  HeroTitle,
  HeroBody,
  CtaRow
} from './HeroStyledComponents'

const scrollToContact = () => {
  const contact = document.getElementById('contact')
  if (contact) {
    contact.scrollIntoView({ behavior: 'smooth' })
  }
}

const Hero = () => (
  <HeroSection>
    <HeroDescription>
      <HeroTitle>
        <FormattedMessage id="homepage.hero.title" />
      </HeroTitle>
      <HeroBody>
        <FormattedMessage id="homepage.hero.body" />
      </HeroBody>
      <CtaRow>
        <Button variant="primary" onClick={() => { window.location.href = RAMBLA_URL }}>
          <FormattedMessage id="homepage.hero.seeRambla" />
        </Button>
        <Button variant="secondary" onClick={scrollToContact}>
          <FormattedMessage id="homepage.hero.talkToUs" />
        </Button>
      </CtaRow>
    </HeroDescription>
    <HeroArt />
  </HeroSection>
)

Hero.displayName = 'Hero'

export default Hero
